import { SipUserAssignmentCreateRequest } from "../../model/sipUserAssignmentCreateRequest";
import { fetchPostJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = SipUserAssignmentCreateRequest;

export async function postSipUserAssignments(payload: DtoType) {
  try {
    const url = apiUrls.postSipUserAssignments;
    return await fetchPostJSON(url, payload);
  } catch (err) {
    console.error("API Error - postSipUserAssignments:", err);
  }
}
